export default class PolicyJwtServices {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.permissionsEndpoint}/policy`, payload)
  }

  update(policy_id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.permissionsEndpoint}/policy/${policy_id}`, payload)
  }

  fetch(policy_id) {
    return this.axiosIns.get(`${this.jwtConfig.main.permissionsEndpoint}/policy/${policy_id}`)
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.permissionsEndpoint}/policy`, { params })
  }

  delete(policy_id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.permissionsEndpoint}/policy/${policy_id}`)
  }
}
